export function getTeamOnlyOptions(teams) {
  const teamOptions = teams.map(option => Object.assign({}, option, {
    containsFreeUsers: false,
    text: option.title
  }));
  return teamOptions;
}